import React from "react";
import { Grid, GridColumn, Icon, Image, Popover, Text } from "@bookingcom/bui-react";
import { Trans, useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import Container from "../Container/index.js";
import useIsBR from "../../../hooks/useIsBR.js";
import Frame from "../Frame/index.js";
import { mcn } from "../../../utils/mergeClassnames.js";
import styles from "./UspBlock.module.css";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import useUserAgent from "../../../hooks/useUserAgent.js";
const UspBlock = ({ hideBackground = false, isPPCVariant = false }) => {
    const i18n = useI18n();
    const isBR = useIsBR();
    const { isMobile } = useUserAgent();
    const showUsp3Tooltip = isPPCVariant && !isMobile;
    const useSmallerSizes = isPPCVariant && isMobile;
    const usps = [
        {
            asset: {
                setName: "illustrations-traveller",
                assetName: "MagnifyingGlassUsp"
            },
            header: i18n.trans(t("flights_index_usp1_header")),
            subheader: i18n.trans(t("flights_index_usp1_copy"))
        },
        isBR
            ? {
                asset: {
                    setName: "illustrations-traveller",
                    assetName: "MoneyUsp"
                },
                header: i18n.trans(t("flights_index_instalment_usp_header")),
                subheader: i18n.trans(t("flights_index_instalment_usp_copy"))
            }
            : {
                asset: {
                    setName: "illustrations-traveller",
                    assetName: "MoneyUsp"
                },
                header: i18n.trans(t("flights_index_usp2_header")),
                subheader: i18n.trans(t("flights_index_usp2_copy"))
            },
        {
            asset: {
                setName: "illustrations-traveller",
                assetName: "TicketsUsp"
            },
            header: i18n.trans(t("flights_index_usp3_header")),
            subheader: showUsp3Tooltip
                ? i18n.trans(t("flights_index_usp3_copy_no_asterisk"))
                : i18n.trans(t("flights_index_usp3_copy")),
            tooltip: showUsp3Tooltip ? (React.createElement(Popover, { triggerType: "hover", position: "bottom-end", hideClose: true, navigationMode: "tab", trapFocusMode: "soft", keepMounted: true },
                React.createElement(Popover.Trigger, null, (attrs) => (React.createElement("span", { tabIndex: 0, ...attrs, "aria-labelledby": "usp_3_tooltip", className: styles.icon_wrapper },
                    React.createElement(Icon, { attributes: { "aria-hidden": true }, size: "small", svg: InfoSignIcon })))),
                React.createElement(Popover.Content, { attributes: {
                        "aria-label": i18n.trans(t("flights_index_usp3_disclaimer_no_asterisk")),
                        role: "tooltip",
                        id: "usp_3_tooltip"
                    } },
                    React.createElement(Text, { variant: "body_1" },
                        React.createElement(Trans, { tag: "flights_index_usp3_disclaimer_no_asterisk" }))))) : undefined
        }
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { className: mcn(!hideBackground && styles.container) },
            React.createElement(Grid, { className: mcn(styles.grid, isPPCVariant && !hideBackground && styles.grid__no_mt) }, usps.map((usp, index) => (React.createElement(GridColumn, { className: mcn(styles.uspContainer, useSmallerSizes && styles.uspContainer__padding), key: index, size: {
                    s: 12,
                    m: 4
                } },
                React.createElement(Frame, { wrap: "nowrap", alignItems: "center", direction: "row" },
                    React.createElement(Frame, { className: mcn(!useSmallerSizes && styles.uspImageWrapper), mr: 4 },
                        React.createElement(Image, { asset: usp.asset, width: useSmallerSizes ? "48px" : "80px", height: useSmallerSizes ? "48px" : "80px", contentMode: "fit", attributes: { "aria-hidden": true } })),
                    React.createElement("div", null,
                        React.createElement(Text, { variant: useSmallerSizes ? "strong_2" : "headline_3", tagName: "h2" }, usp.header),
                        React.createElement(Text, { variant: useSmallerSizes ? "small_1" : "body_2", color: "neutral_alt" },
                            usp.subheader,
                            " ",
                            !!usp.tooltip && usp.tooltip)))))))),
        !showUsp3Tooltip && (React.createElement(Container, { className: mcn(styles.disclaimerContainer, useSmallerSizes && styles.disclaimerContainer__small), pl: useSmallerSizes ? 8 : undefined, pr: useSmallerSizes ? 8 : undefined },
            React.createElement(Text, { variant: useSmallerSizes ? "small_2" : "body_2", color: "neutral_alt" },
                React.createElement(Trans, { tag: "flights_index_usp3_disclaimer" }))))));
};
export default UspBlock;
